import makeClasses from './SwitchModeIOS.style';

import type { SwitchModeIOSProps } from './switchModeIOS.model';

export function SwitchModeIOS(props: SwitchModeIOSProps) {
  const {
    id,
    name,
    checked,
    color = 'primary',
    stopPropagation = false,
    onCheck,
  } = props;

  const _classes = makeClasses({ checked, color });

  return (
    <div
      aria-label='SwitchModelOS'
      className={_classes.container}
      onClick={e => stopPropagation && e.stopPropagation()}
    >
      <input
        id={id}
        name={name}
        type='checkbox'
        checked={checked}
        onChange={event => onCheck?.(event.target.checked)}
        className={_classes.checked}
      />
      <label htmlFor={id} className={_classes.label} />
    </div>
  );
}
